import GearIcon from '@/CustomIcons/GearIcon'
import { Button } from '@/UIComponents2/Button'
import { cn } from '@/utlis/cn'
import { AudioInputStreamInfo } from '@/UserContext'
import { HQIndicator } from '@/pages/SessionPage/internal/shared/HQIndicator'

type DeviceLabelRowProps = {
    label: string
    info: AudioInputStreamInfo
    hasError?: boolean
    onOpenSettings: () => void
    children?: React.ReactNode
}
export function DeviceLabelRow(props: DeviceLabelRowProps) {
    return (
        <div className="w-full flex justify-between items-center">
            <div className="w-[85%] flex gap-[8px] items-center">
                <div className={cn('truncate', props.hasError && 'text-muse-danger')}>{props.label}</div>
                {props.children}
                <HQIndicator mediaStreamInfo={props.info} onClick={() => props.onOpenSettings()} />
            </div>
            <Button onClick={() => props.onOpenSettings()} className="opacity-80 hover:opacity-100">
                <GearIcon className="-mt-1" style={{ fontSize: '1.3rem' }} />
            </Button>
        </div>
    )
}
